import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ArrowLeft } from 'lucide-react';

const BackToHome = () => {
  const { language } = useLanguage();

  return (
    <div className="fixed bottom-6 left-6 z-50">
      <Link
        to="/#capabilities"
        data-testid="back-to-home-btn"
        className="inline-flex items-center gap-2 px-4 py-2.5 bg-[#1A1A1A]/95 backdrop-blur-md border border-white/15 rounded-full text-sm text-white/70 hover:text-white hover:border-white/30 transition-all shadow-lg hover:shadow-xl"
        onClick={() => {
          setTimeout(() => {
            const el = document.getElementById('capabilities');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
          }, 100);
        }}
      >
        <ArrowLeft className="w-4 h-4" strokeWidth={1.5} />
        <span>{language === 'fr' ? 'Retour' : 'Back'}</span>
      </Link>
    </div>
  );
};

export default BackToHome;
